import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-328">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
        <div className="flex justify-between h-16" data-id="element-330">
          <div className="flex items-center" data-id="element-331">
            <div className="flex-shrink-0 flex items-center" data-id="element-332">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n3jPhtJTNKhPH3zdXCdrwT/neocube_blau.png" alt="neocube.pro Logo" className="h-12" data-id="element-333" />
            </div>
          </div>
          <nav className="hidden md:flex md:items-center md:space-x-8" data-id="element-334">
            {['Start', 'Hintergrund', 'Änderungen', 'Angebot', 'Über uns', 'Kontakt'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-335">
                {item}
              </a>)}
            <a href="#kontakt" className="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-md text-sm font-medium" data-id="element-336">
              Beratung anfragen
            </a>
          </nav>
          <div className="flex items-center md:hidden" data-id="element-337">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-338">
              {isMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-339" /> : <MenuIcon className="block h-6 w-6" data-id="element-340" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && <div className="md:hidden" data-id="element-341">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-342">
            {['Start', 'Hintergrund', 'Änderungen', 'Angebot', 'Über uns', 'Kontakt'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-343">
                {item}
              </a>)}
            <a href="#kontakt" className="block w-full text-center bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-md text-base font-medium mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-344">
              Beratung anfragen
            </a>
          </div>
        </div>}
    </header>;
}